import * as React from 'react'

import { Box, Tag, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  legalEntities: string[]
}

const RelatedLegalEntities = ({ legalEntities }: Props) => {
  const [tooltipOpen, toggleToolip] = useToggle(false)
  const legalEntitiesCount = legalEntities.length - 1

  return (
    <Box flexDirection={'column'} alignItems={'flexStart'} gap="s8">
      <Tooltip.ItemList
        open={tooltipOpen}
        toggle={toggleToolip}
        attachment="top center"
        size="auto"
      >
        <Box flexDirection="row" alignItems="center" gap="s4">
          <Tag type="grey">{`+${legalEntitiesCount}`}</Tag>
        </Box>
        <Text.Normal size="200" weight={'bold'}>
          {i18n
            .t(
              'documents.document_templates.all_available_variables_list.entities.related_entities'
            )
            .toUpperCase()}
        </Text.Normal>
        {legalEntities.map((entity) => (
          <Text.Normal size="100" key={entity}>
            {entity}
          </Text.Normal>
        ))}
      </Tooltip.ItemList>
    </Box>
  )
}

export default RelatedLegalEntities
